module.exports = __webpack_public_path__ + "static/media/no-attachments.e8ae3d98.svg";